import Dexie from "dexie";

export const db = new Dexie("AstroAppDB");

// ✅ define tables (users + astrologers)
db.version(1).stores({
  users: "++id, email, phone, password, role",
  astrologers: "++id, email, phone, password, role",
  wallet_transactions: "++id, astrologer_id, type, amount, created_at",
  bookings: "++id, astrologer_id, user_id, status, created_at",
});
